import Sidebars from "./SideBar";
import SassPmsList from "../../pages/PMS/LOGIN";
import NotificationMessage from "./NotificationMessage";
import useNotificationSignalR from "../../hooks/useNotificationSignalR";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Container,
  FormSelect,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { putVesselDetail } from "../../features/commonSlice";
import { fetchVesselApi } from "../../features/vesselSlice";
import { BsBellFill } from "react-icons/bs";
import {
  fetchNotificationFeed,
  fetchUnreadCount,
  pushNotification,
  resetNotifications,
} from "../../features/notificationSlice";
import { logout } from "../../pages/Settings/logout";

const NavMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const path = useMemo(() => {
    const storedPath = localStorage.getItem("loginPath");
    return storedPath ? JSON.parse(storedPath) : null;
  }, []);
  const pathName = path?.pathName;

  const [showNotification, setShowNotification] = useState(false);
  const [profileToggle, setProfile] = useState(false);

  const { unreadCount = 0, gate } = useSelector(
    (state) => state.root.notification,
  );

  const { first_name, Designation } = useSelector(
    (state) => state.root.login.loginDemo,
  );

  const loginDetails = useSelector((state) => state.root.login.loginDemo);

  const vessel_id = useSelector(
    (state) => state.root.common.vessel_detailByID?.id,
  );

  const vessel_list = useSelector((state) => state.root.vessel.list);

  const appVersionNumber = process.env.REACT_APP_VERSION;

  const vesselList =
    useSelector((state) => state.root.login.loginDemo?.vesselDetails) || [];

  const vessel_Option = vesselList.map((x, i) => (
    <option key={x.id + "_" + i} value={x.id}>
      {x.vessel_name}
    </option>
  ));

  const notificationsEnabled = Boolean(
    loginDetails?.isLogin && !loginDetails?.is_admin,
  );

  // The feed is the source of truth; the socket only accelerates it. It is not
  // scoped to the selected vessel — see notificationSlice.
  const refreshNotifications = useCallback(() => {
    if (!notificationsEnabled) return;

    dispatch(fetchNotificationFeed());
    dispatch(fetchUnreadCount());
  }, [dispatch, notificationsEnabled]);

  // Clear the previous session's rows rather than showing them to whoever signs
  // in next. A vessel switch no longer needs one — the bell spans every vessel.
  useEffect(() => {
    dispatch(resetNotifications());
    refreshNotifications();
  }, [dispatch, refreshNotifications]);

  useEffect(() => {
    if (!loginDetails.isLogin) return;

    dispatch(fetchVesselApi())
      .unwrap()
      .then((res) => {
        let vesselList = res.filter((x) => x.vessel_name === "OFFICE");
        vessel_id === undefined && dispatch(putVesselDetail(vesselList[0]));
      });
  }, [dispatch, loginDetails.isLogin, vessel_id]);

  useEffect(() => {
    !loginDetails.isLogin && (pathName === "/login" || pathName === "/")
      ? navigate("/login")
      : !loginDetails.isLogin &&
          (pathName === "/saas-login" || pathName === "/")
        ? navigate("/saas-login")
        : !loginDetails.isLogin &&
          pathName === "/admin-login" &&
          navigate("/admin-login");

    !loginDetails.isLogin && path === null && navigate("/login");
  }, [loginDetails.isLogin, navigate, path, pathName]);

  useNotificationSignalR({
    enabled: notificationsEnabled,
    // The push carries the same shape as a feed row, so it needs no refetch.
    onNotification: (message) => {
      if (message) dispatch(pushNotification(message));
    },
    onReconnected: refreshNotifications,
  });

  const vesselChange = (arg) => {
    const vesselDetail = vessel_list.filter((x) => x.id === Number(arg));
    if (!vesselDetail[0]) {
      toast.error("This vessel isn't available right now — please pick another one.");
      return;
    }
    dispatch(putVesselDetail(vesselDetail[0]));
  };

  const handleBellClick = () => {
    setShowNotification(!showNotification);
  };

  return (
    <div>
      <SassPmsList />
      {!loginDetails?.is_admin && (
        <Navbar className="appHeader" expand="lg" fixed="top">
          <Container fluid>
            <Navbar.Toggle aria-controls="headerNavbarNav" />
            <Navbar.Collapse id="headerNavbarNav">
              <Nav className="ms-auto">
                {/* The feed is gated per tenant — where it is off, the bell does
                    not exist at all rather than showing an empty or errored one. */}
                {gate !== "disabled" && (
                  <div className={"position-relative me-5"}>
                    <BsBellFill
                      style={{ color: "#8798B2", cursor: "pointer" }}
                      className={"notify me-2 align-content-center d-flex"}
                      onClick={handleBellClick}
                    />
                    {showNotification && !loginDetails?.is_admin && (
                      <div
                        className={"position-fixed bg-white rounded"}
                        style={{
                          marginTop: "-1px",
                          marginLeft: "-310px",
                          boxShadow: "0 0 10px rgba(0, 0, 0, 0.14)",
                          width: "340px",
                        }}
                      >
                        <NotificationMessage
                          onNavigate={() => setShowNotification(false)}
                        />
                      </div>
                    )}
                    {unreadCount > 0 && (
                      <span className={"position-absolute notify-count"}>
                        {unreadCount}
                      </span>
                    )}
                  </div>
                )}

                <FormSelect
                  className={"me-2 top-select"}
                  onChange={(e) => vesselChange(e.target.value)}
                  value={vessel_id || ""}
                >
                  <option value="" disabled>
                    Choose Vessel
                  </option>
                  {vessel_Option}
                </FormSelect>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}

      <div className="leftFixed12">
        <Sidebars setProfile={(e) => setProfile(e)} />
        <NavDropdown
          title={
            <div className="d-flex">
              <div className="avatar">
                {loginDetails?.repository &&
                loginDetails.repository.length > 0 ? (
                  <img
                    src={loginDetails.repository[0].fileurl}
                    alt={"profile"}
                    title={"user"}
                  />
                ) : (
                  <i className="fa fa-fw fa-user" />
                )}
              </div>
              {!profileToggle && (
                <div
                  className="d-flex justify-content-start flex-column"
                  style={{ marginLeft: "5px" }}
                >
                  <div> {first_name}</div>
                  <span>{Designation}</span>
                </div>
              )}
            </div>
          }
          align="end"
          id="headerNavDropdown"
          className="profile-menu"
          style={{
            position: "fixed",
            width: "180px",
            bottom: 18,
            color: "#fff",
          }}
        >
          <NavDropdown.Item href="#">My Profile</NavDropdown.Item>
          <NavDropdown.Item href="#action">Settings</NavDropdown.Item>
          <NavDropdown.Item href="#action">Help</NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item onClick={() => logout()}>Logout</NavDropdown.Item>
        </NavDropdown>

        <div
          style={{
            position: "fixed",
            width: "180px",
            bottom: 0,
            color: "#fff",
            display: "flex",
            justifyContent: "center",
            fontSize: "12px",
          }}
        >
          Version: {appVersionNumber} {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
};

export default NavMenu;
